export class OrganizeModel {
  company?: string;
  channel?: string;
  center?: string;
  saleOrgId?: number;
}
